import { Badge } from '@payaca/ambrosia';
import { FC, useMemo, type JSX } from 'react';

import { PrelineColourVariant } from '@payaca/types/preline';
import { ScheduledEventTaskStatus } from '@payaca/types/scheduledEventsTypes';

type Props = {
  status?: ScheduledEventTaskStatus;
};

const ScheduledEventTaskStatusBadge: FC<Props> = ({
  status,
}: Props): JSX.Element | null => {
  const state = useMemo<PrelineColourVariant>(() => {
    switch (status) {
      case 'No tasks':
        return 'gray';
      case 'Completed':
        return 'green';
      case 'Partially completed':
        return 'yellow';
      case 'Not started':
        return 'blue';
      default:
        return 'gray';
    }
  }, [status]);

  if (!status) return null;

  return (
    <Badge variant="soft" colour={state} rounded>
      {status}
    </Badge>
  );
};

export default ScheduledEventTaskStatusBadge;
